import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function Opera360BridgeFooter() {
  return (
    <footer className="bg-[#0F172A] text-white pt-24 pb-10 relative overflow-hidden">
      <div className="absolute -top-32 left-1/3 w-[30rem] h-[30rem] rounded-full bg-[#FF5722]/10 blur-3xl" />
      <div className="absolute -bottom-40 -left-20 w-[26rem] h-[26rem] rounded-full bg-[#2563EB]/10 blur-3xl" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="font-display font-black tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-7xl max-w-4xl"
        >
          Empower every <span className="text-[#FF5722]">human</span> with{" "}
          <span className="text-[#F59E0B]">Opera360</span>.
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.7 }}
          className="mt-10 flex flex-wrap items-center gap-4"
        >
          <a
            data-testid="footer-opera360-link"
            href="https://www.opera360trains.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#FF5722] text-white font-bold text-sm hover:bg-white hover:text-[#0F172A] transition-colors duration-300"
          >
            Visit opera360trains.com <ArrowUpRight className="w-4 h-4" />
          </a>
          <a href="#ai-tools" className="inline-flex items-center gap-2 px-8 py-4 rounded-full border-2 border-white/15 font-bold text-sm text-slate-300 hover:border-[#F59E0B] hover:text-[#F59E0B] transition-colors duration-300">
            Replay the AI tools
          </a>
        </motion.div>

        <div className="mt-16 grid sm:grid-cols-3 gap-8 border-t border-white/10 pt-10 text-sm">
          <div>
            <img src="/brand/opera360hr-lockup.png" alt="Opera360 HR — Empower Every Human" className="w-72 max-w-full rounded-2xl border border-white/10" />
            <p className="text-slate-400 mt-3 leading-relaxed">
              The people-first HR intelligence layer — ChatGPT concierge, Claude document architect,
              and a live CRM, wired into the Opera360 operating standard.
            </p>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500">Platform</div>
            <div className="mt-3 space-y-2 text-slate-400">
              <a href="#features" className="block hover:text-white transition-colors">Features</a>
              <a href="#ai-tools" className="block hover:text-white transition-colors">Ziggy · ChatGPT Concierge</a>
              <a href="#doc-drafter" className="block hover:text-white transition-colors">Milo · Claude Drafter</a>
              <a href="#crm-demo" className="block hover:text-white transition-colors">Live CRM Demo</a>
              <a href="#founder" className="block hover:text-white transition-colors">Founder Story</a>
              <a href="/admin" className="block text-[#F59E0B] hover:text-white transition-colors font-bold">CRM Admin Login</a>
            </div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500">Ecosystem</div>
            <div className="mt-3 space-y-2 text-slate-400">
              <a href="https://www.opera360trains.com" target="_blank" rel="noopener noreferrer" className="block hover:text-white transition-colors">Opera360 Trains ↗</a>
              <a href="https://www.scopeonewalk.com" target="_blank" rel="noopener noreferrer" className="block hover:text-white transition-colors">ScopeOne Walk ↗</a>
              <div className="text-slate-500">TRAIN · WALK · AUDIT · COACH · COMMAND</div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-wrap items-center justify-between gap-4 text-xs text-slate-500 font-medium">
          <span>© 2026 Opera360 AI · A Christopher Love platform</span>
          <span className="font-mono2">AI drafts are a starting point — review with HR/legal counsel.</span>
        </div>
      </div>
    </footer>
  );
}
